import http from "infra/http";
import { useQuery } from "react-query";
import {
  MovimentacaoBancariaListagemResponse,
  MovimentacaoBancariaRequestParams,
} from "../typings";

function useMovimentacoesBancarias(
  query: MovimentacaoBancariaRequestParams,
  options?: { enabled?: boolean }
) {
  return useQuery(
    [`/v1/movimentacao-financeira`, query],
    async () => {
      const { data } = await http.get<MovimentacaoBancariaListagemResponse>(
        `/v1/movimentacao-financeira`,
        {
          params: query,
        }
      );

      return data;
    },
    {
      enabled: options?.enabled ?? true,
    }
  );
}

export default useMovimentacoesBancarias;
